<mat-checkbox
  (change)="$event ? emailsService.masterToggle() : null"
  color="primary"
  [checked]="
    emailsPageStateService.selection.hasValue() && emailsService.isAllSelected
  "
  [indeterminate]="
    emailsPageStateService.selection.hasValue() && !emailsService.isAllSelected
  ">
</mat-checkbox>
